<div
  class="tw-fixed tw-top-0 tw-box-border tw-flex tw-h-[60px] tw-w-[260px] tw-items-center tw-border-0 tw-border-b tw-border-solid tw-border-slate-300 tw-bg-white tw-px-5">
  <h2 class="tw-text-lg tw-font-bold tw-text-slate-800">Notifications</h2>
  <ate-icon class="tw-ml-auto tw-size-6 tw-cursor-pointer tw-text-slate-800" (click)="closeNotificationsMenu()" name="close-v2"></ate-icon>
</div>
<app-notification-list
  class="tw-mt-[60px] tw-block"
  [notifications]="notifications"
  *ngIf="notifications?.length > 0; else empty"></app-notification-list>

<ng-template #empty>
  <ate-ui-utility-message class="!tw-mt-[60px] tw-block !tw-px-5 !tw-py-8" [config]="config"></ate-ui-utility-message>
</ng-template>
